import {
  Button,
  Grid,
  TextField,
  Tooltip,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import WisconsinAdditionalInfoForm from './wisconsinAdditionalInfoForm';
import RhodeIslandAdditionalInfoForm from './rhodeIslandAdditionalInfoForm';
import { packTypeOptions } from '../../../../../../data/forms/nrc/stolenAndMissingDropdownOptions';
import { yesNoOptions } from '../../../../../../data/forms/generalDropdownOptions';

export default function AdditionalInfoModal({
  isOpen,
  handleClose,
  jid,
  handleChange,
  form,
}) {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Grid
        container
        spacing={2}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%', sm: '60%', md: '75%' },
          maxHeight: { xs: '80vh', sm: '100vh', md: '100vh' },
          overflowY: 'auto',
          bgcolor: 'var(--dust-white)',
          p: 4,
        }}
      >
        <Grid size={12}>
          <Typography
            id='modal-modal-title'
            sx={{ fontFamily: 'BrightstarSans-Regular', fontSize: '25px' }}
          >
            {`${jid} Additional Information`}
          </Typography>
        </Grid>
        {jid === 'Wisconsin' ? (
          <WisconsinAdditionalInfoForm
            handleChange={handleChange}
            form={form}
          />
        ) : jid === 'Rhode Island' ? (
          <RhodeIslandAdditionalInfoForm
            handleChange={handleChange}
            form={form}
          />
        ) : (
          <>
            <Grid size={{ xs: 12, sm: 6 }}>
              <FormControl
                required
                sx={{
                  backgroundColor: '#ffffff',
                  marginBottom: '15px',
                  width: '100%',
                }}
              >
                <InputLabel>{'Pack Type'}</InputLabel>
                <Select
                  value={form.packTypes}
                  label={'Pack Type'}
                  onChange={handleChange}
                  name='packTypes'
                >
                  {packTypeOptions.map(jid => (
                    <MenuItem value={jid}>{jid}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Tooltip
                title={
                  "Did you inform the Retailer a representative of the Jurisdiction's State Lottery Security will contact them on the next business day?"
                }
                arrow
              >
                <FormControl
                  required
                  sx={{
                    backgroundColor: '#ffffff',
                    marginBottom: '15px',
                    width: '100%',
                  }}
                >
                  <InputLabel>
                    {'Informed Retailer of Security Callback'}
                  </InputLabel>
                  <Select
                    value={form.lotterySecurityCallback}
                    label={'Informed Retailer of Security Callback'}
                    onChange={handleChange}
                    name='lotterySecurityCallback'
                  >
                    {yesNoOptions.map(jid => (
                      <MenuItem value={jid}>{jid}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Tooltip>
              <Tooltip
                title={
                  'Did you encourage the Retailer to report the theft to the local police?'
                }
                arrow
              >
                <FormControl
                  required
                  sx={{
                    backgroundColor: '#ffffff',
                    marginBottom: '15px',
                    width: '100%',
                  }}
                >
                  <InputLabel>
                    {'Encouraged Retailer to Report to Police'}
                  </InputLabel>
                  <Select
                    value={form.encouragedRetailer}
                    label={'Encouraged Retailer to Report to Police'}
                    onChange={handleChange}
                    name='encouragedRetailer'
                  >
                    {yesNoOptions.map(jid => (
                      <MenuItem value={jid}>{jid}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Tooltip>
              <Tooltip
                title={
                  'If the local police opened a case please add a case number here'
                }
                arrow
              >
                <TextField
                  label='Police Case Number (If Applicable)'
                  name='caseNum'
                  disabled={form.jurisdiction === 'Wisconsin'}
                  sx={{
                    backgroundColor: '#ffffff',
                    marginBottom: '15px',
                    width: '100%',
                  }}
                  value={form.caseNum}
                  onChange={handleChange}
                />
              </Tooltip>
              {jid !== 'Washington' && (
                <Tooltip
                  title={
                    'Does the Caller Have Any Uncertainty About the Accruacy of the Game / Pack Number or Ticket Ranges They Are Reporting?'
                  }
                  arrow
                >
                  <FormControl
                    required
                    sx={{
                      backgroundColor: '#ffffff',
                      marginBottom: '15px',
                      width: '100%',
                    }}
                  >
                    <InputLabel>{'Accuracy Uncertainty'}</InputLabel>
                    <Select
                      value={form.accuracyUncertainty}
                      label={'Accuracy Uncertainty'}
                      onChange={handleChange}
                      name='accuracyUncertainty'
                    >
                      {yesNoOptions.map(jid => (
                        <MenuItem value={jid}>{jid}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Tooltip>
              )}
              {jid !== 'Washington' && jid !== 'Nebraska' && (
                <>
                  {jid !== 'New York' && (
                    <Tooltip
                      title={
                        'Brightstar must refer Retailer to the Lottery for questions regarding pack fee.'
                      }
                      arrow
                    >
                      <FormControl
                        required
                        sx={{
                          backgroundColor: '#ffffff',
                          marginBottom: '15px',
                          width: '100%',
                        }}
                      >
                        <InputLabel>
                          {
                            'Advised Retailer of $25/pack Fee for Confirmed Packs'
                          }
                        </InputLabel>
                        <Select
                          value={form.advisedFee}
                          label={
                            'Advised Retailer of $25/pack Fee for Confirmed Packs'
                          }
                          onChange={handleChange}
                          name='advisedFee'
                        >
                          {yesNoOptions.map(jid => (
                            <MenuItem value={jid}>{jid}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Tooltip>
                  )}
                  <Tooltip
                    title={
                      "Did you call the Retailer back at store to verify the caller's identity?"
                    }
                    arrow
                  >
                    <FormControl
                      required
                      sx={{
                        backgroundColor: '#ffffff',
                        marginBottom: '15px',
                        width: '100%',
                      }}
                    >
                      <InputLabel>{'Called Retailer Back'}</InputLabel>
                      <Select
                        value={form.calledRetailerBack}
                        label={'Called Retailer Back'}
                        onChange={handleChange}
                        name='calledRetailerBack'
                      >
                        {yesNoOptions.map(jid => (
                          <MenuItem value={jid}>{jid}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Tooltip>
                </>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label='Number of Packs Missing'
                name='packsMissing'
                required
                fullWidth
                value={form.packsMissing}
                onChange={handleChange}
                sx={{ backgroundColor: '#ffffff', marginBottom: '15px' }}
              />
              <TextField
                label='How were the tickets reported identified?'
                name='howTicketNumbersReported'
                value={form.howTicketNumbersReported}
                onChange={handleChange}
                multiline
                required
                rows={4.1}
                sx={{
                  backgroundColor: '#ffffff',
                  marginBottom: '15px',
                  width: '100%',
                }}
              />
              <TextField
                label='Additional Comments'
                name='comments'
                value={form.comments}
                onChange={handleChange}
                multiline
                rows={4.1}
                sx={{
                  backgroundColor: '#ffffff',
                  marginBottom: '15px',
                  width: '100%',
                }}
              />
            </Grid>
          </>
        )}
        <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: 'var(--vega-blue)' }}
            onClick={handleClose}
          >
            {'Done'}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
